<template>
  <div>
    <DefaultHeader />
    <section class="vh-auto">
      <div class="container h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
          <div class="col col-lg-12 mb-4 mb-lg-0">
            <div class="card mb-3 shadow p-3 mb-5 bg-body rounded" style="border-radius: .5rem;">
              <div class="card-body p-4">
                <div class="row align-items-center mb-2">
                  <div class="col">
                    <h5 class="mb-0 text-truncate">Disponibilité services</h5>
                  </div>
                </div>
                <hr class="mb-4 mt-0" />
                <div class="ratio ratio-16x9">
                  <iframe
                    src="https://stats.uptimerobot.com/wOItzxlBYy"
                    title="UptimeRobot Status"
                    loading="lazy"
                    style="border:0;"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <DefaultFooter />
  </div>
 </template>

 <script>
 import DefaultHeader from '@/components/DefaultHeader.vue'
 import DefaultFooter from '@/components/DefaultFooter.vue'

 export default {
   name: 'UptimeStatus',
   components: { DefaultHeader, DefaultFooter },
 }
 </script>
